exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{\r\n   border-radius: 5px;\r\n}\r\n\r\n .ng-invalid:not(form)  {\r\n   border-left: 5px solid #a94442; /* red */\r\n }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-upload/feedback-upload.component.css
// module id = ../../../../../src/app/feedback-upload/feedback-upload.component.css
// module chunks = main